import { render } from "./RecruitmentRequirementDrawer.vue?vue&type=template&id=60aa8a08&scoped=true"
import script from "./RecruitmentRequirementDrawer.vue?vue&type=script&lang=js"
export * from "./RecruitmentRequirementDrawer.vue?vue&type=script&lang=js"

import "./RecruitmentRequirementDrawer.css?vue&type=style&index=0&id=60aa8a08&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60aa8a08"]])

export default __exports__